import { render, staticRenderFns } from "./drip-campaign-email-statistics.vue?vue&type=template&id=b5a450bc"
import script from "./drip-campaign-email-statistics.vue?vue&type=script&lang=js"
export * from "./drip-campaign-email-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports